import React from "react"
import classNames from "classnames"

export interface ParagraphProps {
  children: string
  align?: "left" | "center" | "right"
  level: 1 | 2 | 3 | 4
  lineClamp?: 2 | "none"
}

export const Paragraph = ({
  children,
  align = "left",
  level,
  lineClamp,
}: ParagraphProps) => {
  const className = classNames({
    "full-width text-gray-500 antialiased": true,
    "text-p1-mobile md:text-p1-desktop": level === 1,
    "text-p2-mobile md:text-p2-desktop": level === 2,
    "text-p3-mobile md:text-p3-desktop": level === 3,
    "text-p4-mobile md:text-p4-desktop": level === 4,
    "text-left": align === "left",
    "text-center": align === "center",
    "text-right": align === "right",
    "line-clamp-2": lineClamp === 2,
    "line-clamp-none": lineClamp === "none",
  })

  return <p className={className}>{children}</p>
}
